import { CONVERSATIONAL_MM_AGENT } from '@fruitful/llm-service-shared';
import { BodySmallRegular, Spinner, XStack, YStack } from 'smoothie';

import { ConversationalMMArtifact } from '../conversational-mm/ConversationalMMArtifact';
import { useGetAdminMastraThread } from '../hooks/useGetAdminMastraThread';

/**
 * Agent-aware results panel for the thread detail view. Dispatches to the
 * appropriate renderer based on agentId. Add new agents by adding a branch
 * here and a corresponding results renderer.
 */
export const AiThreadResultsPanel = ({
    agentId,
    mastraThreadId,
}: {
    agentId: string | undefined;
    mastraThreadId: string;
}) => {
    const { data: thread, isLoading } = useGetAdminMastraThread({
        mastraThreadId,
    });

    if (isLoading) {
        return (
            <XStack justifyContent="center" padding="$6">
                <Spinner />
            </XStack>
        );
    }

    if (thread?.results == null) {
        return (
            <YStack padding="$4">
                <BodySmallRegular color="$gray700">
                    No results recorded for this thread.
                </BodySmallRegular>
            </YStack>
        );
    }

    if (agentId === CONVERSATIONAL_MM_AGENT.id) {
        return (
            <YStack
                alignSelf="flex-start"
                borderWidth={1}
                borderColor="$gray300"
                borderRadius={12}
                overflow="hidden"
            >
                <ConversationalMMArtifact results={thread.results} />
            </YStack>
        );
    }

    return (
        <YStack padding="$4">
            <BodySmallRegular color="$gray700">
                No results renderer available for this agent type.
            </BodySmallRegular>
        </YStack>
    );
};
